import { render, staticRenderFns } from "./CreateTPQuestionForm.vue?vue&type=template&id=1d613296&scoped=true&"
import script from "./CreateTPQuestionForm.vue?vue&type=script&lang=js&"
export * from "./CreateTPQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d613296",
  null
  
)

export default component.exports